import { render, staticRenderFns } from "./templateThumbnail.vue?vue&type=template&id=10e85bae&scoped=true"
import script from "./templateThumbnail.vue?vue&type=script&lang=js"
export * from "./templateThumbnail.vue?vue&type=script&lang=js"
import style0 from "./templateThumbnail.vue?vue&type=style&index=0&id=10e85bae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e85bae",
  null
  
)

export default component.exports